// 分步表单公共的props
export const component_props = {
  // 表单项键名
  formKey: {
    type: String,
    required: true,
  },
  // 表单项配置
  formItem: {
    type: Object,
    required: true,
  },
  // 表单配置
  formFields: {
    type: Object,
    required: true,
  },
  // 初始化数据
  initOps: {
    type: Object,
    required: true,
  },
};
